import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import ShareBlock from "@/components/ShareBlock";

export default function MembershipSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  return (
    <div data-testid="membership-success-page">
      <section className="bg-[#F7F4ED] section-pad">
        <div className="container-phs">
          <div className="card-default max-w-2xl mx-auto text-center">
            <CheckCircle2 className="mx-auto text-[#064E2E]" size={48}/>
            <h1 className="font-display text-3xl sm:text-4xl mt-4 text-[#071A33]">Welcome to Park Home Support</h1>
            <p className="mt-4 text-[#334155]">
              Thank you for joining. Your membership is being activated — once Stripe confirms the payment, your account will be marked active and you'll receive a confirmation email.
            </p>
            {sessionId && <p className="mt-4 text-xs text-[#475569]">Reference: {sessionId}</p>}
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/request-support" className="btn-primary" data-testid="success-request-support-btn">Request Support <ArrowRight size={16}/></Link>
              <Link to="/" className="btn-outline" data-testid="success-home-btn">Back to Home</Link>
            </div>
          </div>

          <div className="max-w-2xl mx-auto mt-6">
            <ShareBlock
              refCode={sessionId || ""}
              title="Know someone else dealing with a park home issue?"
              body="If a friend, neighbour or relative is about to approve work or struggling with a quote, send them this — it could save them from making the same costly mistake."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
